import type { NextPage } from 'next'
import { useState } from 'react'
import OptionsButton from 'componentsUnits/optionsButton'
import { OptionElement, OptionsList } from 'componentsUnits/optionsList'
import styles from './EntryScrollableComponent.module.scss'

interface Props {
  type: string
  options?: OptionElement[]
  children?: JSX.Element
}

const EntryScrollableComponentContainer: NextPage<Props> = (props: Props) => {
  const [optionsVisible, setOptionsVisible] = useState(false)

  return (
    <div className={styles.container}>
      {props.type &&
        <div className={styles.typeContainer}>
          <div className={`${styles.type} ${props.options && styles.typePushLeft}`}>{props.type}</div>
          {props.options &&
            <>
              <OptionsButton onClick={() => setOptionsVisible(true)} />
              <OptionsList options={props.options} visible={optionsVisible} onClose={() => setOptionsVisible(false)} />
            </>
          }
        </div>
      }
      {props.children}
    </div>
  )
}

export default EntryScrollableComponentContainer
